<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.SN码')" prop="deviceSn">
        <el-input v-model="formData.deviceSn">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-form-item>


      <el-form-item v-show="Object.keys(deviceInfo).length">
        <el-descriptions :column="1" class="device-desc">
          <el-descriptions-item :label="$t('lang.SN码')">{{ deviceInfo.sn }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lang.品牌')">{{ deviceInfo.brandOwnerName}}</el-descriptions-item>
          <el-descriptions-item :label="$t('lang.型号')">{{ deviceInfo.productModel }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lang.地区')">{{ deviceInfo['countryName'] }}/{{ deviceInfo['provinceName'] }}/{{ deviceInfo['cityName'] }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lang.账户')">{{  deviceInfo.userAccount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lang.昵称')">{{ deviceInfo.userNickname }}</el-descriptions-item>
        </el-descriptions>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
export default {
  name: "TestDeviceAdd",
  components: {},
  data() {
    return {
      api: {
        add: this.$api.testDevice.add,
        search: this.$api.testDevice.search
      },
      formErrorMsg: {account: ''},
      formData: {
        deviceSn: ''
      },
      deviceInfo: {}
    }

  },
  computed: {
    rules() {
      return {
        deviceSn: [
          {required: true, message: this.$t('lang.SN码不能为空'), trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    handleSearch() {
      const vm = this;
      vm.$refs['form'].validate((valid) => {
        if(valid) {
          vm.$http.get(vm.api.search, {params: {sn: vm.formData['deviceSn']}}).then(res => {
            if(res.data.status != 200) {
              vm.$message.error(this.$t('lang.' + res.data.desc));
              return;
            }
            vm.deviceInfo = res.data.data['device'];
            console.log(vm.deviceInfo);
          })
        }
      })
    },

    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          vm.$http.post(vm.api.add, this.$qs.stringify(this.formData)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: this.$t('lang.' +resp.data.desc)
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              console.log(vm.$refs[form]);




              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: this.$t('lang.' +resp.data.desc)
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: this.$t('lang.' +resp.data.desc)
              })
            }

          }).catch(err => {
            let res = err.response;
            if(res.data) {
              this.$message.error(this.$t('lang.' + res.data.message) || "请求出错")
            }
          })
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
      this.deviceInfo = {};
    }
  }
  ,
  created() {
    // let vm = this;

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}

.device-desc {
  border: 1px solid #dddddd;
  padding: 24px;
}


</style>
